import { render, staticRenderFns } from "./dialog-sendonechat.vue?vue&type=template&id=500b4fc8&"
import script from "./dialog-sendonechat.vue?vue&type=script&lang=js&"
export * from "./dialog-sendonechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports